var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { Loader, InstantCollapsible } from "sb-resp-ui";
// external components
import * as CMP from "./components";
import * as SCMP from "../../components";
import Debounce from "debounce-decorator";
import { TypeExtends } from "sb-js-extends";
TypeExtends();
let MyPulseBets = class MyPulseBets extends React.Component {
    constructor(props) {
        super(props);
        this.dict = this.props.dict;
        // setup data provider
        this.state = {
            dataProvider: this.props.dataProvider,
            changedResolution: false
        };
    }
    componentDidMount() {
        window.addEventListener("resize", this);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this);
    }
    handleEvent(e) {
        this.handleResizeEvent(e);
    }
    handleResizeEvent(e) {
        if (e.type === "resize") {
            this.setState((prevState) => ({ changedResolution: !prevState.changedResolution }));
        }
    }
    getKey(pulseBetTypeData) {
        return `eventTypeCollapsible-${pulseBetTypeData.eventTypeId}-${+this.state.changedResolution}`;
    }
    renderMyPulseBetContainer(pulseBetTypeData) {
        return (React.createElement("div", { className: "rj-my-pusle-bets__collapsible-wrap", key: this.getKey(pulseBetTypeData) },
            React.createElement(InstantCollapsible, { trigger: React.createElement(CMP.SortedHeading, { text: pulseBetTypeData.eventTypeName }), content: React.createElement("div", { className: "rj-my-pulse-bets__main-container" }, this.state.dataProvider.getOpenPulseBets(pulseBetTypeData.eventTypeId).map(this.renderOpenPulseBets, this)), initiallyExpanded: true })));
    }
    renderOpenPulseBets(myOpenPulseBet) {
        return (React.createElement(CMP.OpenPulseBet, { key: myOpenPulseBet.uniqueKey, viewModel: myOpenPulseBet, winMsg: this.dict.PulseBetMsgWin.format(myOpenPulseBet.formatedGain), goMsg: this.dict.PulseBetMsgGoal, isGameRunning: this.state.dataProvider.isGameRunning, callbacks: {
                complete: this.state.dataProvider.updateWiningsStatusOnComplete.bind(this.state.dataProvider)
            }, calculateState: this.state.dataProvider.reCalculateState.bind(this.state.dataProvider, myOpenPulseBet.purchaseId) }));
    }
    renderLoader() {
        return (React.createElement("div", { className: "rj-my-pulse-bets__loader" },
            React.createElement(Loader, null)));
    }
    renderMessage() {
        return (React.createElement("div", { className: "rj-my-pulse-bets__no-open-pulse-bets" }, this.dict.NoOpenPulseBets));
    }
    renderAllPulseBets() {
        return (React.createElement(React.Fragment, null,
            React.createElement(SCMP.Heading, { label: this.dict.MyPulseBets }),
            !this.state.dataProvider.openViewModels.length && (this.state.dataProvider.isAnyBetsAfterSettlement ? this.renderLoader() : this.renderMessage()),
            (this.state.dataProvider.openViewModels.length > 0) &&
                this.state.dataProvider.pulseBetTypes.map(data => this.state.dataProvider.hasAnyOpenPulseBets(data.eventTypeId) && this.renderMyPulseBetContainer(data))));
    }
    render() {
        return (React.createElement(React.Fragment, null, this.state.dataProvider.isMyPulseBetActive &&
            this.renderAllPulseBets()));
    }
};
__decorate([
    Debounce(50),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Event]),
    __metadata("design:returntype", void 0)
], MyPulseBets.prototype, "handleResizeEvent", null);
MyPulseBets = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], MyPulseBets);
export { MyPulseBets };
//# sourceMappingURL=MyPulseBets.js.map